import { Button } from 'primereact/button';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { useReplyConversationMutation } from '../../features/coaching/conversationLogs/conversationLogSlice';
import { selectCurrentEmpid, selectCurrentUserFullName } from '../../pages/login/authSlice';
import { changeDateFormate, datetimeToDate } from '../../utils/dateFormat';
import DescriptionBox from '../descriptionBox/DescriptionBox';

interface ReplyConversationLogProps {
    listItem: any;
    setCommentView: (commentView: boolean) => void;
    setIsResponse: (isResponse: boolean) => void;
    setSelectedRowItem?: (selectedRowItem: any) => void;
    isResponse: boolean;
    readOnly?: boolean;
}

const ReplyConversationLog = (props: ReplyConversationLogProps) => {
    const [ReplyConversation] = useReplyConversationMutation();
    const currEmpId = useSelector(selectCurrentEmpid);
    const currEmpName = useSelector(selectCurrentUserFullName);
    const [responseDescription, setResponseDescription] = useState('');

    const now = new Date();
    const bottomRef = useRef<HTMLDivElement>(null);
    const topRef = useRef<HTMLDivElement>(null);

    const handleDescriptionChange = (value: string) => {
        setResponseDescription(value);
    };

    useEffect(() => {
        setResponseDescription(props.listItem?.response_description);
        if (props.isResponse) {
            window.scrollTo(0, 0);
        } else bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [props]);

    const handleCancel = () => {
        if (props.listItem?.response_employee_number === currEmpId) {
            setResponseDescription(props.listItem?.response_description);
        }
        else {
            setResponseDescription('');
            if (props && props.setCommentView) {
                props.setCommentView(false);
            }
            if (props && props.setIsResponse) {
                props.setIsResponse(false);
            }
        }
    };

    const validate = () => {
        if (responseDescription.trim().length < 10) {
            toast.error('Description is required and must be at least 10 characters');
            return false;
        }

        if (responseDescription.trim().length > 4000) {
            toast.error('Description cannot exceed 4000 characters');
            return false;
        }
        return true;
    };

    const handleSave = () => {
        if (!validate()) return;
        if (props.listItem?.response_description === responseDescription) {
            return;
        }
        const request = {
            coachingConversationId: props.listItem?.coaching_conversation_id,
            responseEmployeeNumber: currEmpId,
            responseDescription,
            responseDate: props.isResponse ? props.listItem?.response_date : `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`,

        };
        ReplyConversation(request)
            .unwrap()
            .then((res: any) => {
                if (res?.data) {
                    toast.success('Discussion updated successfully');
                    if (props && props.setIsResponse) {
                        props.setIsResponse(true);
                        const rowDetails = {
                            ...props.listItem,
                            responder: currEmpId,
                            "response_by_name": currEmpName,
                            "response_description": responseDescription,
                            "response_date": now
                        };
                        if (props.setSelectedRowItem)
                            props.setSelectedRowItem(rowDetails);
                    }
                } else {
                    toast.error('Error updating Discussion');
                }

                if (props && props.setCommentView) {
                    props.setCommentView(false);
                }
            })
            .catch(() => {
                toast.error('Error updating Discussion');
            });
    };

    return (
        <>
            <div ref={topRef} />
            <div className="d-flex justify-content-start">
                <div className="col-1 p-3">
                    <i className="turnDownRight" />
                </div>

                <div className="logConversation col-11 mb-2 mt-3">
                    <div className="col-3 mb-3">
                        <h6>Date</h6>
                        <div>
                            {props.isResponse && props.listItem?.response_date
                                ? changeDateFormate(datetimeToDate(props.listItem?.response_date))
                                : changeDateFormate(datetimeToDate(now))}
                        </div>
                    </div>
                    <div className="mb-2">
                        <DescriptionBox
                            createdByLabel="Response by"
                            createdByValue={props.isResponse ? props.listItem?.response_by_name : currEmpName}
                            title={'Description'}
                            limit={4000}
                            readOnly={((props.isResponse && props.listItem?.response_employee_number !== currEmpId) || props.listItem?.acknowledged || props.readOnly)}
                            responseDescription={
                                props.isResponse ? props.listItem?.response_description : responseDescription
                            }
                            value={responseDescription
                            }
                            onChange={handleDescriptionChange}
                        />
                        <div ref={bottomRef} />
                    </div>

                    {/* Hiding to do in add comments section */}
                    {/* {props.isResponse && (
                        <div className="d-flex justify-content-end mt-3">
                            <CoachingToDo
                                receiverId={props.receiverId}
                                receiverName={props.receiverName}
                                visible={todoVisible}
                                setVisible={setTodoVisible}
                                coachingEntityId={props.convId}
                                coachingEntityTypeId={2}
                                coachingStatusId={1}
                            />
                        </div>
                    )} */}
                    {((!props.isResponse || props.listItem?.response_employee_number === currEmpId) && !props.listItem?.acknowledged && !props.readOnly) && (
                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                label="Cancel"
                                onClick={handleCancel}
                                className="me-2 btn-secondary"
                            />
                            <Button label="Save" onClick={handleSave} className="btn-primary" />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
};
export default ReplyConversationLog;
